import { createFileRoute } from "@tanstack/react-router"
import { AixContentBody } from "@aix/ui"
import { ReactElement } from "react"
import AISoundEffectsTool from "~/components/Steppers/AISoundEffectsTool"
import CustomHead from "~/components/SEOHead/CustomHead"
import AppLayout from "~/layouts/AppLayout"
import { BreadcrumbBanner } from "~/components/BreadcrumbBanner"
import { getPageSEO } from "~/utils/seo"

function AISoundEffectsPage() {
  const breadcrumbItems = [{ label: "Home", href: "/home" }, { label: "AI Sound Effects" }]
  const aiSoundEffectsSEO = getPageSEO("tools/ai-sound-effects")

  return (
    <>
      <BreadcrumbBanner items={breadcrumbItems} />
      <CustomHead
        title={aiSoundEffectsSEO.title}
        description={aiSoundEffectsSEO.description}
        keywords={aiSoundEffectsSEO.keywords}
        pageType={aiSoundEffectsSEO.pageType}
        url="https://vidmax.ai/tools/ai-sound-effects"
      />
      <div className="space-y-6">
        <AixContentBody>
          <AISoundEffectsTool />
        </AixContentBody>
      </div>
    </>
  )
}

function AISoundEffectsPageWrapper() {
  return (
    <AppLayout>
      <AISoundEffectsPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/tools/ai-sound-effects")({
  component: AISoundEffectsPageWrapper,
})
